import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import { DriverSyncStatus, isBusyDriver } from 'components/Erp/IntegrationTrip';
import { DateTime, Vehicle } from 'components/Erp/Display';
import React from 'react'
import { Truck, Search, ChevronLeft, ChevronRight } from 'lucide-react'
import s from './PanelBase.module.scss'
import { SectionHeading, EmptyState } from 'components/Erp/Presentation'
import DriverInfoCard from '../../../components/DriverInfoCard/DriverInfoCard'
import DriverIdentity from '../../ReportCard/components/DriverIdentity';

const ReadOnlyDriversList = ({
  base,
  drivers = [],
  driversFilter = '',
  setDriversFilter = () => {},
  loadDriversPage = () => {},
  driversPagination = {},
  expandedDriver = {},
  toggleDriver = () => {},
  title = tr("Транспорт"),
}) => {
  useInterfaceLanguage();
  const safeDrivers = Array.isArray(drivers) ? drivers : []

  const vehicleBadgeClass = (d) => {
    if (d.status === 'blocked') return s.blocked
    if (d.status === 'in_route') return s.route
    if (d.status === 'in_loading' || isBusyDriver(d.status)) return s.loading
    return s.free
  }

  return (
    <div className={s.subPanel}>
      <SectionHeading icon={Truck} title={tr(title)} as="h3" />

      <div className={s.searchRow}>
        <Search size={16} aria-hidden="true" />
        <input
          className={s.searchInput}
          placeholder={tr("Поиск по водителю...")}
          value={driversFilter || ''}
          onChange={(e) => setDriversFilter(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') loadDriversPage(base.id, 1, driversFilter || '') }}
        />
      </div>

      {safeDrivers.length ? (
        <>
          <div className={s.tableWrap}>
            <div className={s.tableScroll}>
            <table className={s.table}>
              <thead>
                <tr>
                  <th>{tr("Автомобиль")}</th>
                  <th>{tr("Водитель")}</th>
                  <th>№</th>
                  <th>{tr("Телефон")}</th>
                  <th>{tr("Доп. тел.")}</th>
                  <th>{tr("Модель")}</th>
                  <th>{tr("UID")}</th>
                  <th>{tr("QR")}</th>
                  <th>{tr("Фото")}</th>
                  <th>{tr("QR фото")}</th>
                  <th>{tr("Создано")}</th>
                  <th>{tr("Активность")}</th>
                  <th>{tr("Статус машины")}</th><th>{tr("Синхронизация")}</th>
                </tr>
              </thead>
              <tbody>
                {safeDrivers.map((d, index) => (
                  <React.Fragment key={d.id}>
                    <tr
                      onClick={(e) => {
                        if (e.target && (e.target.tagName === 'BUTTON' || e.target.tagName === 'A' || e.target.tagName === 'INPUT' || e.target.tagName === 'IMG' || (e.target.closest && e.target.closest('button')))) return
                        toggleDriver(base.id, d.id)
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      <td data-label={tr("Автомобиль")}><Vehicle number={d.vehicle_number} model={d.vehicle_model} /></td>
                      <td data-label={tr("Водитель")} className={s.nameCell}><DriverIdentity name={d.employee_name || tr("Без водителя")} phone={d.employee_phone} mobilePhone /></td>
                      <td data-label={tr("№")} className={s.numCell}>{tr(index + 1)}</td>
                      <td data-label={tr("Телефон")} className={s.separatePhone}>{tr(d.employee_phone || '—')}</td>
                      <td data-label={tr("Доп. тел.")}>{tr(d.phone || '—')}</td>
                      <td data-label={tr("Модель")}>{tr(d.vehicle_model || '—')}</td>
                      <td data-label={tr("UID")}>
                        {d.uid ? (
                          <button className={s.uidBtn} onClick={(ev) => {
                            ev.stopPropagation()
                            try {
                              if (navigator?.clipboard?.writeText) {
                                navigator.clipboard.writeText(d.uid)
                              } else {
                                const ta = document.createElement('textarea')
                                ta.value = d.uid
                                document.body.appendChild(ta)
                                ta.select()
                                document.execCommand('copy')
                                ta.remove()
                              }
                            } catch (e) {}
                          }}>{tr(d.uid)}</button>
                        ) : '—'}
                      </td>
                      <td data-label={tr("QR")} style={{ fontSize: 12, color: "var(--theme-text-muted, #64748b)" }}>{tr(d.qrcode_scr || '—')}</td>
                      <td data-label={tr("Фото")}>
                        {d.photo ? <img className={s.thumb} src={d.photo?.url || d.photo} alt={`driver-${d.id}`} /> : '—'}
                      </td>
                      <td data-label={tr("QR фото")}>
                        {d.qrcode_img ? <img className={s.thumb} src={d.qrcode_img?.url || d.qrcode_img} alt={`qr-${d.id}`} /> : '—'}
                      </td>
                      <td data-label={tr("Создано")} style={{ fontSize: 12, color: "var(--theme-text-muted, #64748b)" }}><DateTime value={d.created_at} /></td>
                      <td data-label={tr("Активность")}>
                        <span className={`${s.badge} ${d.is_active ? s.active : s.inactive}`}>
                          {d.is_active ? tr("Активен") : tr("Неактивен")}
                        </span>
                      </td>
                      <td data-label={tr("Статус машины")}>
                        <span className={`${s.badge} ${vehicleBadgeClass(d)}`}>
                          {tr(d.status_display || d.status || tr("Свободен"))}
                        </span>
                      </td><td data-label={tr("Синхронизация")}><DriverSyncStatus driver={d} /></td>
                    </tr>

                    {tr(expandedDriver[base.id] === d.id && (
                      <tr className={s.subRow}>
                        <td colSpan={14}>
                          <div className={s.subContent}>
                            <div className={s.driverDetail}>
                              <div className={s.driverDetailTitle}>{tr("Детали водителя: ")}{tr(d.employee_name || String(d.employee))}
                              </div>
                              <div className={s.detailGrid}>
                                <div className={s.detailRow}>
                                  <span className={s.detailKey}>{tr("Номер машины")}</span>
                                  <span className={s.detailVal}>{tr(d.vehicle_number || '—')}</span>
                                </div>
                                <div className={s.detailRow}>
                                  <span className={s.detailKey}>{tr("Модель")}</span>
                                  <span className={s.detailVal}>{tr(d.vehicle_model || '—')}</span>
                                </div>
                                <div className={s.detailRow}>
                                  <span className={s.detailKey}>{tr("Телефон сотрудника")}</span>
                                  <span className={s.detailVal}>{tr(d.employee_phone || '—')}</span>
                                </div>
                                <div className={s.detailRow}>
                                  <span className={s.detailKey}>{tr("Доп. телефон")}</span>
                                  <span className={s.detailVal}>{tr(d.phone || '—')}</span>
                                </div>
                                <div className={s.detailRow}>
                                  <span className={s.detailKey}>{tr("UID")}</span>
                                  <span className={s.detailVal}>{tr(d.uid || '—')}</span>
                                </div>
                                <div className={s.detailRow}>
                                  <span className={s.detailKey}>{tr("QR строка")}</span>
                                  <span className={s.detailVal}>{tr(d.qrcode_scr || '—')}</span>
                                </div>
                                <div className={s.detailRow}>
                                  <span className={s.detailKey}>{tr("Статус")}</span>
                                  <span className={s.detailVal}>
                                    <span className={`${s.badge} ${d.is_active ? s.active : s.inactive}`}>
                                      {d.is_active ? tr("Активен") : tr("Неактивен")}
                                    </span>
                                  </span>
                                </div>
                                <div className={s.detailRow}>
                                  <span className={s.detailKey}>{tr("Статус машины")}</span>
                                  <span className={s.detailVal}>
                                    <span className={`${s.badge} ${vehicleBadgeClass(d)}`}>
                                      {tr(d.status_display || d.status || tr("Свободен"))}
                                    </span>
                                  </span>
                                </div>
                                <div className={s.detailRow}>
                                  <span className={s.detailKey}>{tr("Дата создания")}</span>
                                  <span className={s.detailVal}><DateTime value={d.created_at} /></span>
                                </div>
                              </div>
                            </div>
                            <DriverInfoCard driver={d} />
                          </div>
                        </td>
                      </tr>
                    ))}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
            </div>
          </div>

          {tr(driversPagination?.count > 0 && (
            <div className={s.pagination}>
              <button className={s.pageBtn} disabled={!driversPagination.previous} onClick={() => loadDriversPage(base.id, (driversPagination.page || 1) - 1, driversFilter)}><ChevronLeft size={15} aria-hidden="true" />{tr("Пред.")}</button>
              <span>{tr("Стр. ")}{tr(driversPagination.page || 1)}{tr(" из ")}{Math.ceil(driversPagination.count / 25)}</span>
              <button className={s.pageBtn} disabled={!driversPagination.next} onClick={() => loadDriversPage(base.id, (driversPagination.page || 1) + 1, driversFilter)}>{tr("След.")}<ChevronRight size={15} aria-hidden="true" /></button>
            </div>
          ))}
        </>
      ) : (
        <EmptyState icon={Truck} title={tr("Водители не найдены")} description={tr("Измените поисковый запрос или выберите другой объект.")} compact />
      )}
    </div>
  )
}

export default ReadOnlyDriversList
